import React, { useState } from 'react';
import {
  Stack,
  Pagination,
  Select,
  MenuItem,
  Button,
  TextField,
  Typography,
  useMediaQuery,
} from '@mui/material';

// CONFIG
import Config from '../../Config';

// MESSAGES
import RootComponentsFormattedMessages from '../../messages/RootComponentsFormattedMessages';

// Components
import CustomModal from './CustomModal';
import HelpTooltip from './HelpTooltip';

const Paginator = ({
  pageNumber,
  setPageNumber,
  itemCount,
  pageLength,
  changeEvent,
  editFunction,
  showTotal,
  toolTip,
}) => {
  const [pageModal, setPageModal] = useState(false);
  const [typedPage, setTypedPage] = useState(null);
  const lgAndUp = useMediaQuery((theme) => theme.breakpoints.up('lg'));

  const handlePageCount = () => {
    return itemCount
      ? Math.ceil(itemCount / (pageLength || Config.defaultPL))
      : 0;
  };

  const handlePageSelect = () => {
    let pageCount = handlePageCount();
    let page = Number(typedPage);
    if (page >= 1 && page <= pageCount) {
      setPageNumber(page - 1);
      setPageModal(false);
      setTypedPage(null);
      changeEvent && changeEvent(page);
    }
  };

  const handlePageChange = (event, value) => {
    changeEvent && changeEvent(value);
  };

  const renderEditDropdown = () =>
    editFunction && (
      <Stack sx={{ flexDirection: 'row', alignItems: 'center', gap: 0.5 }}>
        <Select
          value={pageLength || 10}
          onChange={(e) => editFunction(e)}
          size="small"
          sx={{
            '& .MuiSelect-select': {
              paddingY: 0.75,
              backgroundColor: 'common.white',
            },
          }}
        >
          {[10, 50, 100].map((size) => (
            <MenuItem key={size} value={size}>
              {size}
            </MenuItem>
          ))}
        </Select>
        <Typography fontSize={12}>Per Page</Typography>
      </Stack>
    );

  let pageCount = handlePageCount();
  if (pageCount === 0) return null;

  return (
    <Stack
      sx={{
        flexDirection: { md: 'row' },
        alignItems: 'center',
        gap: { xs: 2, md: 5 },
        marginLeft: { md: 2 },
      }}
    >
      <Pagination
        count={pageCount}
        onChange={handlePageChange}
        page={pageNumber}
        showFirstButton
        showLastButton
        siblingCount={lgAndUp ? 1 : 0}
        size={lgAndUp ? 'medium' : 'small'}
        sx={{
          backgroundColor: 'common.white',
          border: '1px solid',
          borderColor: 'secondary.light',
          borderRadius: 2,
          '& .MuiPaginationItem-root': {
            borderRadius: 0,
            '&:focus': {
              outlineColor: 'grey.500',
            },
          },
          '& .MuiPaginationItem-root.Mui-selected': {
            backgroundColor: 'secondary.light',
          },
        }}
      />
      {renderEditDropdown()}

      <Stack sx={{ flexDirection: 'row', gap: 0.5, alignItems: 'center' }}>
        {showTotal && (
          <Typography fontSize={12}>
            {showTotal}: {itemCount}
          </Typography>
        )}
        {toolTip && (
          <HelpTooltip message={<Typography>{toolTip}</Typography>} />
        )}
      </Stack>

      <CustomModal
        title={`Select Page between 1 & ${pageCount}`}
        open={pageModal}
        onClose={() => setPageModal(false)}
      >
        <TextField
          type="number"
          value={typedPage || ''}
          onChange={(e) => setTypedPage(e.target.value)}
          size="small"
          slotProps={{
            htmlInput: {
              min: 1,
              max: pageCount,
            },
          }}
        />

        <Button onClick={handlePageSelect}>
          {RootComponentsFormattedMessages.go}
        </Button>
      </CustomModal>
    </Stack>
  );
};

export default Paginator;
